module.exports = __webpack_public_path__ + "static/media/caseStudyHeroImage.06e6d387.jpg";